/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/style-prop-object */
// import React, { useEffect, useRef } from 'react';
import React from 'react';
import PropTypes from 'prop-types';
// import useNebula from 'hooks/useNebula';

// import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
// import useQlikSessionObject from 'hooks/useQlikSessionObject';
import useStyles from './styles';
import TranslationTxt from '../TranslationTxt/TranslationTxt';

// import AppContext from '../AppContext';

const MapSection = ({
  header,
  text,
}) => {
  const classes = useStyles();

  // const nebula = useNebula();
  //   const { qlikApp } = useContext(AppContext);
  // const mapRef = useRef();

  // useEffect(async () => {
  //   if (!nebula) return;
  //   mapRef.current = await nebula.render({
  //     type: 'map',
  //     element: mapRef.current,
  //     options: {
  //       configuration: {
  //         // serverUrl: 'https://maps.qlikcloud.com',
  //         // serverKey: '123456',
  //       },
  //     },
  //     // id: '1c8c34ce-ba79-4545-9df0-0fc206af426f',
  //     properties: {
  //       gaLayers: [
  //         {
  //           type: 'PointLayer',
  //           qHyperCubeDef: {
  //             qDimensions: [
  //               {
  //                 qDef: {
  //                   qFieldDefs: [
  //                     '1c8c34ce-ba79-4545-9df0-0fc206af426f',
  //                   ],
  //                 },
  //                 qAttributeExpressions: [
  //                   {
  //                     qExpression: 'latitude',
  //                     id: 'locationOrLatitude',
  //                   },
  //                   {
  //                     qExpression: 'longitude',
  //                     id: 'longitude',
  //                   },
  //                 ],
  //               },
  //             ],
  //             qMeasures: [],
  //             qInitialDataFetch: [
  //               {
  //                 qLeft: 0,
  //                 qTop: 0,
  //                 qWidth: 1,
  //                 qHeight: 10000,
  //               },
  //             ],
  //           },
  //           size: {
  //             radiusMin: 4,
  //             radiusMax: 12,
  //           },
  //           color: {
  //             mode: 'primary',
  //             paletteColor: {
  //               index: 9,
  //               color: '#f8981d',
  //             },
  //           },
  //           locationOrLatitude: {
  //             key: 'latitude',
  //             type: 'expression',
  //           },
  //           isLatLong: true,
  //           id: 'tWTdanX',
  //         },
  //       ],
  //       mapSettings: {
  //         showScaleBar: true,
  //       },
  //     },
  //   });
  // }, [nebula]);

  return (
    <div className="section" style={{ marginBottom: 50, marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
        {/* <span>We matched media outlets to the audience they serve and used a scale to measure the number of journalists. You can explore the map and see where media outlets are across the country. The size of the bubble indicates the number of media outlets in the respective area.</span> */}
      </Typography>
      {/* <div className={classes.mapViz} ref={mapRef} style={{ height: 500 }} /> */}
      <iframe
        // src="https://qdt.qlik.com/single/?appid=288cdb78-f6f5-4912-8940-a5eeb6315bf4&obj=9d7c8c47-4f50-478d-bc96-4f1d3c7d5299&theme=horizon"
        src="https://sense-demo.qlik.com/single/?appid=b50be8f2-90d5-4ba6-9dd5-5d6db9a9cfc1&obj=9d7c8c47-4f50-478d-bc96-4f1d3c7d5299&theme=horizon"
        style={{
          border: 'none', width: '100%', height: '600px', backgroundColor: 'transparent !important',
        }}
      />
    </div>
  );
};

MapSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

MapSection.defaultProps = {
  header: '',
  text: '',
};

export default MapSection;
